import { render, staticRenderFns } from "./CallsGrid.vue?vue&type=template&id=054208c8"
import script from "./CallsGrid.vue?vue&type=script&lang=js"
export * from "./CallsGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports